import React from "react";

export default function MyWorkSummaryCards({ summary, onSelect }) {
  const cards = [
    ["execution","MY EXECUTION",summary.execution,"To Execute","fas fa-clipboard-check","EXECUTION"],
    ["ownership","MY OWNERSHIP",summary.ownership,"Owned by Me","fas fa-user","OWNERSHIP"],
    ["approvals","MY APPROVALS",summary.approvals,"To Approve","fas fa-shield-alt","APPROVALS"],
  ];
  return <div className="my-work-summary">{cards.map(([type,title,value,sub,icon,tab]) =>
    <div key={type} className={`my-work-summary-card ${type}`} role="button" tabIndex={0}
      onClick={()=>onSelect(tab)} onKeyDown={e=>e.key==="Enter"&&onSelect(tab)}>
      <div className="my-work-summary-inner">
        <div className="my-work-summary-icon"><i className={icon}/></div>
        <div><div className="my-work-summary-label">{title}</div><div className="my-work-summary-value">{value}</div><div className="my-work-summary-subtitle">{sub}</div></div>
        <div className="my-work-arrow"><i className="fas fa-chevron-right"/></div>
      </div>
    </div>)}</div>;
}